














import Vue from "vue"

export default Vue.extend({
  name: "BaseLoanOriginatorChip",
  props: {
    loanOriginator: { type: [Object, String], required: true },
  },
  data() {
    return {
      data: {},
      loading: false,
    }
  },
  watch: {
    loanOriginator: {
      immediate: true,
      handler() {
        if (typeof this.loanOriginator == 'string') {
          this.data = { id: this.loanOriginator }
          this.fetch()
        } else {
          this.data = this.loanOriginator
        }
      },
    },
  },
  methods: {
    fetch() {
      this.loading = true
      this.$http.get(`/loan_originators/${this.data.id}/`)
        .then((response) => {
          this.loading = false
          this.data = response.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
})
